import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {AppBar, Box, Hidden, Toolbar, makeStyles, List, ListItem} from '@material-ui/core';
import {IconButton} from 'gatsby-theme-material-ui';
import {Image, DarkModeToggler} from 'components/atoms';
import MenuIcon from '@material-ui/icons/Menu';
import LogoDark from '../../../../assets/images/logos/logo-white.svg';
import Logo from '../../../../assets/images/logos/logo-grey.svg';
import LoginStateCTA from '../../../../components/atoms/LoginStateCTA';

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  logoContainer: {
    width: 100,
    height: 28,
    [theme.breakpoints.up('md')]: {
      width: 120,
      height: 32,
    },
  },
  logoImage: {
    width: '100%',
    height: '100%',
  },
  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  listItem: {
    paddingRight: 0,
  },
  listItemText: {
    flex: '0 0 auto',
    whiteSpace: 'nowrap',
  },
  listItemButton: {
    whiteSpace: 'nowrap',
  },
  iconButton: {
    paddingRight: 0,
    '&:hover': {
      background: 'transparent',
    },
  },
}));

const TopBar = ({className, onMobileNavOpen, themeToggler, themeMode, breadcrumbs, ...rest}) => {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} color="inherit" {...rest}>
      <Toolbar>
        <div className={classes.logoContainer}>
          <a href="/" title="Mediabook">
            <Image
              className={classes.logoImage}
              src={themeMode === 'light' ? Logo : LogoDark}
              alt="Make School"
              lazy={false}
            />
          </a>
        </div>
        <Box flexGrow={1} />
        <Hidden smDown>{breadcrumbs}</Hidden>
        <Box flexGrow={1} />
        <DarkModeToggler themeMode={themeMode} onClick={() => themeToggler()} />
        <Hidden smDown>
          <List disablePadding className={classes.navigationContainer}>
            <ListItem className={clsx(classes.listItem, 'menu-item--no-dropdown')}>
              <LoginStateCTA />
            </ListItem>
          </List>
        </Hidden>
        <Hidden mdUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
            className={classes.iconButton}
            disableRipple
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
  themeToggler: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
};

export default TopBar;
